/**
 * ---------------------------------------------------------------------------
 * NCJ COMPONENT: Product Accordion
 * FILE: ncj-product-accordion.js
 * PURPOSE: Exclusive-open accordion for product page details blocks.
 *          When a details element opens, all sibling details close.
 *          Scoped to .product__accordion within a product info container.
 *          Formerly 'custom-accordion.js'.
 * AUTHOR: No Code Jungle (NCJ)
 * LAST MODIFIED: 2026-03-23
 * ---------------------------------------------------------------------------
 */

(function () {
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.product__accordion summary');
    if (!summary) return;

    var currentDetails = summary.closest('details');
    if (!currentDetails) return;

    var scope =
      currentDetails.closest('.product__info-container') ||
      currentDetails.closest('.product') ||
      document;

    var wasOpen = currentDetails.hasAttribute('open');

    if (!wasOpen) {
      scope.querySelectorAll('.product__accordion details[open]').forEach(function (d) {
        if (d !== currentDetails) d.removeAttribute('open');
      });
    }
  });
})();
